import { subDays, subMonths } from "date-fns";
import { Form } from "semantic-ui-react";
import "react-datepicker/dist/react-datepicker.css";
import { useFlags } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { walmartMXTranslations } from "../../../../translations/walmartMXTranslations.js";
import { AdvertiserField } from "../../common/components/AdvertiserField.jsx";
import { CampaignsField } from "../../common/components/CampaignsField.jsx";
import { DateRangePickerField } from "../../common/components/DateRangePickerField.jsx";
import { DateWindowField } from "../../common/components/DateWindowField.jsx";
import { useReportForm } from "../../hooks/useReportForm";

const DATE_NOW = new Date();
const MINIMAL_START_DATE = subMonths(DATE_NOW, 6);
const MAXIMAL_END_DATE = subDays(DATE_NOW, 1);

const NewToBrandReportForm = ({ values, updateValues, onSubmit, type }) => {
  const {
    advertisers,
    advertisersLoading,
    campaigns,
    campaignsLoading,
    campaignSearchQuery,
    handleStartDateChange,
    handleEndDateChange,
    initialAdvertisers,
    performSearchAdvertisersDebounced,
    resetSelectedCampaigns,
    setAdvertisers,
    setCampaignSearchQuery,
    trimmingSearch,
    performSearchCampaignsDebounced,
    resetCampaigns,
  } = useReportForm({ values, updateValues, type });

  const { whitelabelNewToBrand } = useFlags();
  if (!whitelabelNewToBrand) {
    return <Redirect to="/reports" />;
  }

  return (
    <Form
      autoComplete="off"
      onSubmit={onSubmit}
    >
      <Form.Group>
        <DateWindowField
          values={values}
          updateValues={updateValues}
          dateWindowType="lookback_window"
        />

        <DateRangePickerField
          values={values}
          onStartDateChange={handleStartDateChange}
          onEndDateChange={handleEndDateChange}
          minimalStartDate={MINIMAL_START_DATE}
          maximalEndDate={MAXIMAL_END_DATE}
          tooltipMessage={walmartMXTranslations.ntbDateRangeTooltipText}
        />

        <AdvertiserField
          values={values}
          updateValues={updateValues}
          advertisers={advertisers}
          advertisersLoading={advertisersLoading}
          campaignsLoading={campaignsLoading}
          trimmingSearch={trimmingSearch}
          performSearchAdvertisersDebounced={performSearchAdvertisersDebounced}
          setAdvertisers={setAdvertisers}
          initialAdvertisers={initialAdvertisers}
        />

        <CampaignsField
          values={values}
          updateValues={updateValues}
          campaigns={campaigns}
          campaignsLoading={campaignsLoading}
          advertisersLoading={false}
          trimmingSearch={trimmingSearch}
          resetSelectedCampaigns={resetSelectedCampaigns}
          campaignSearchQuery={campaignSearchQuery}
          setCampaignSearchQuery={setCampaignSearchQuery}
          performSearchCampaignsDebounced={performSearchCampaignsDebounced}
          tooltipMessage={walmartMXTranslations.campaignsWithMeritPixelTooltipText}
          type={type}
          resetCampaigns={resetCampaigns}
        />
      </Form.Group>
    </Form>
  );
};
NewToBrandReportForm.propTypes = {
  values: PropTypes.object.isRequired,
  updateValues: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default NewToBrandReportForm;
